import * as React from 'react';

import * as styles from './Footer.module.scss';
import l10n from '@built/i18n';

/**
 * Renders the page footer
 */
export default function Footer(props: FooterProps) {
  const classes = [styles.footer];
  if (props.className) {
    classes.push(props.className);
  }
  if (props.basic) {
    classes.push(styles.basicFooter);
  }

  return (
    <div className={classes.join(' ')}>
      <p className={styles.footerText}>
        &copy;{' '}
        {l10n.t(
          'Footer:Message.copyright',
          'Copyright {{date}} Built Technologies, Inc.',
          {
            date: new Date().getFullYear()
          }
        )}{' '}
        <a
          href="https://getbuilt.com/privacy-policy"
          target="_blank"
          className={styles.privacyPolicyLink}
        >
          {l10n.t('Footer:Message.privacyPolicy', 'Privacy Policy')}
        </a>
      </p>
    </div>
  );
}

export interface FooterProps {
  /** Optional classes to add to component */
  className?: string;

  /** If true, use basic styling (no border or padding) */
  basic?: boolean;
}
